import React from 'react'
import { Route } from 'react-router-dom'
import Wallet from './Wallet'
import MyWallet from './MyWallet'


const Layout = React.lazy(() => import ('./Layout'))
const MyWalletLayout = React.lazy(() => import ('./MyWallet/Layout'))
const Transactions = React.lazy(() => import ('./Transactions'))
const Send = React.lazy(() => import ('./Send'))
const Recieve = React.lazy(() => import ('./Recieve'))
const Deposit = React.lazy(() => import ('./Deposit'))
const Withdraw = React.lazy(() => import ('./Withdraw'))
const RouteWithProps = React.lazy(() => import ('App/helpers/RouteWithProps'))

export default (
  <Route path="/accounts" element={<React.Suspense><Layout /></React.Suspense>}>
    <Route index element={<React.Suspense><MyWalletLayout /></React.Suspense>} />
    {MyWallet}
    {Wallet}
    <Route path=":code/transactions" element={<React.Suspense><RouteWithProps component={Transactions} /></React.Suspense>} />
    <Route path=":code/send" element={<React.Suspense><RouteWithProps component={Send} /></React.Suspense>} />
    <Route path=":code/receive" element={<React.Suspense><RouteWithProps component={Recieve} /></React.Suspense>} />
    <Route path=":code/deposit" element={<React.Suspense><RouteWithProps component={Deposit} /></React.Suspense>} />
    <Route path=":code/withdraw" element={<React.Suspense><RouteWithProps component={Withdraw} /></React.Suspense>} />
  </Route>
)
